import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { FaSpinner } from 'react-icons/fa';

function EditPublish() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // Navigate back to the previous page
  };

  const localStorageTheme = localStorage.getItem('theme');
  const localStorageWalimatulurus = localStorage.getItem('walimatulurus');
  const localStorageWalimatulurus2 = (localStorage.getItem('walimatulurus2') !== null && localStorage.getItem('walimatulurus2') !== undefined && localStorage.getItem('walimatulurus2') !== "") ? localStorage.getItem('walimatulurus2') : "null";
  const localStorageToggleWalima = localStorage.getItem('toggle_walima');
  const localStorageDoa = localStorage.getItem('doa');
  const localStorageGroomName = localStorage.getItem('groom_name');
  const localStorageBrideName = localStorage.getItem('bride_name');

  const localStorageParentName = localStorage.getItem('parent_name');
  const localStorageMessage = localStorage.getItem('message');
  const localStorageGroomFullName = localStorage.getItem('groom_fullname');
  const localStorageBrideFullName = localStorage.getItem('bride_fullname');

  const localStorageWeddingDate = localStorage.getItem('wedding_date');
  const localStorageLocation = localStorage.getItem('location');
  const localStorageStartTime = localStorage.getItem('start_time');
  const localStorageEndTime = localStorage.getItem('end_time');

  const localStorageTentative = localStorage.getItem('tentative');

  const localStorageContacts = localStorage.getItem('contacts');
  const localStorageDirections = localStorage.getItem('directions');

  const localStorageH2 = localStorage.getItem('H2');
  const localStorageH2size = localStorage.getItem('H2size');
  const localStorageFontP = localStorage.getItem('fontP');
    
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const defaultTentative = [
    { "title": "Kehadiran tetamu", "displaytime": "11:30 AM", "time":"11:30"},
    { "title": "Ketibaan Pengantin", "displaytime": "12:30 PM", "time":"12:30"},
    { "title": "Makan Beradab", "displaytime": "1:30 PM", "time":"13:30"},
    { "title": "Majlis Berakhir", "displaytime": "4:00 PM", "time":"16:00"},
  ];

  const demoContacts = [
    {
      "name": "Adam",
      "phoneNumber": "0123456789",
      "contactMethod": "both"
    },
  ];

  const demoDirections = [
    {
      "locationName": "Corus Hotel",
      "wazeUrl": "https://ul.waze.com/ul?preview_venue_id=66650144.666566972.474270&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location",
      "googleMapsUrl": "https://maps.app.goo.gl/FxK74Gyh4wxyP1Nx9"
    }
  ];

  const theme = (localStorageTheme || "theme3");
  const walimatulurus = (localStorageWalimatulurus || "walimatulurus");
  const walimatulurus2 = (localStorageWalimatulurus2 || "Walimatulurus");
  const toggle_walima = (localStorageToggleWalima || true);
  const doa = (localStorageDoa || "Ya Allah Ya Rahman Ya Rahim.\nBerkatilah majlis perkahwinan ini.\nLimpahkanlah baraqah dan rahmatMu kepada kedua mempelai ini. Kurniakanlah mereka kelak zuriat yang soleh dan solehah. Kekalkanlah jodoh mereka hingga ke jannah.");
  const groom_name = (localStorageGroomName || "Adam");
  const bride_name = (localStorageBrideName || "Hawa");
  const wedding_date = (localStorageWeddingDate ? new Date(localStorageWeddingDate) : tomorrow);

  const parent_name = (localStorageParentName || "Abdul Razak bin Abdullah\n&\nAminah binti Ali");
  const message = (localStorageMessage || "Dengan penuh kesyukuran, kami menjemput Dato' | Datin | Tuan | Puan | Encik | Cik seisi keluarga hadir ke majlis perkahwinan anakanda kami");
  const groom_fullname = (localStorageGroomFullName || "Muhammad Adam bin Abdul Razak");
  const bride_fullname = (localStorageBrideFullName || "Siti Hawa binti Faizal");

  const location = (localStorageLocation || "Corus Hotel");
  const streetAddress = (localStorage.getItem('streetAddress') || "Persiaran Hampshire, Jalan Ampang");
  const city = (localStorage.getItem('city') || "Kuala Lumpur");
  const state = (localStorage.getItem('state') || "Wilayah Persekutuan Kuala Lumpur");
  const zipCode = (localStorage.getItem('postcode') || "50450"); 
  const start_time = (localStorageStartTime || "11:30");
  const end_time = (localStorageEndTime || "17:00");

  const tentative = (localStorageTentative || defaultTentative);

  const contacts = (localStorageContacts || demoContacts);
  const directions = (localStorageDirections || demoDirections);

  const H2 = localStorageH2;
  const H2size = localStorageH2size;
  const fontP = localStorageFontP;
  // const status = "verified";

  // const [id, setId] = useState(null);
  
  useEffect(() => { 
    const apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/update-cards/${id}`; 

    const dataToSave = {
      theme,
      walimatulurus,
      walimatulurus2,
      toggle_walima,
      doa,
      groom_name,
      bride_name,
      wedding_date,
      parent_name,
      message,
      groom_fullname,
      bride_fullname,
      location,
      streetAddress,
      city,
      state,
      zipCode,
      start_time,
      end_time,
      tentative,
      contacts,
      directions,
      H2,
      fontP,
      H2size,
      // status,
    };

    axios.put(apiEndpoint, dataToSave)
      .then(response => {
        console.log(response.data);
        // setId(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error saving data:', error);
        setLoading(false);
      });
  }, []);

  const url = `https://app.panggilanmajlis.com/kad/${id}`;
  const event = `${groom_name}x${bride_name}`;

  const handleShare = () => {

    if (navigator.share) {
      navigator.share({
        title: 'Walimatulurus',
        text: `Jemputan Walimatulurus ${event}`,
        url: url,
      })
        .then(() => console.log('Successful share'))
        .catch((error) => console.error('Error sharing:', error));
    } else {
      alert(`Share this link: ${url}`);
    }
  };

  return (
    <div>
      {loading ? ( 
        <div className="mt-12 flex items-center justify-center">
          <FaSpinner className="text-4xl text-purple-600 animate-spin" />
        </div>
      ) : (
        <div className="bg-white px-8 py-12 rounded-md md:shadow-lg max-w-md w-full text-center">
          <h1 className="text-2xl font-bold mb-4">Kad kahwin Digital anda telah berjaya diubah.</h1>
          <p className="text-gray-700 mb-4">
          Klik butang dibawah untuk lihat kad. 
          </p>
          {/* <input
            type="text"
            value={url}
            readOnly
            // ref={inputRef}
            className="border px-5 py-3 mb-2 w-full"
          /> */}
          <div className='flex flex-col items-center justify-center space-y-2'>
            <a
              href={url}
              target="_blank"
              className="btn-primary text-center px-5 py-3 rounded w-full"
            >
              Lihat Kad
            </a>
            <button onClick={handleBack}
              className="btn-secondary text-center px-5 py-3 rounded w-full"
            >
              Kembali ke Dashboard
            </button>
          </div>
        </div>
      )}
    </div>
      
  );
}

export default EditPublish;